// Tracks whether the user has picked which shop she's working from *this
// browser session*. A multi-shop user is asked to choose right after login (the
// Netflix-style ShopChooserGate); once she picks we don't nag her again on every
// reload. Keyed by userId so a different sign-in on the same tab must re-choose.
// Stored in sessionStorage, so closing the tab naturally clears it.
const KEY = 'kalachand:shop-chosen';

export function markShopChosen(userId: string): void {
  try {
    sessionStorage.setItem(KEY, userId);
  } catch {
    /* storage unavailable (private mode / quota) — fall back to always prompting */
  }
}

export function hasChosenShop(userId: string): boolean {
  try {
    return sessionStorage.getItem(KEY) === userId;
  } catch {
    return false;
  }
}

export function clearShopChoice(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
